import { adminApi } from "../../api"
import { ApiControllers } from "../../api/config"


const fetchScreenPermissions = (featureId, customerId ) => {
    return adminApi.get(ApiControllers.security + `Toolbar/${customerId}/${featureId}`);
}
const fetchMenuItems = (customerId,appId) => {
    return adminApi.get(ApiControllers.security + `Features/${process.env.REACT_APP_APP_ID}/${customerId}`);
}

export { fetchScreenPermissions, fetchMenuItems }